import React from 'react';
import { cx } from '@twind/core';
import { ChatItemStaticImage } from 'app/services/chatBot';

import useVirtualAssistantAvatar from '../../hooks/useVirtualAssistantAvatar';
import BaseChatItem from './BaseChatItem';

export default function StaticImageChatItem({
  chatItem,
  hideAvatar,
  className,
}: {
  chatItem: ChatItemStaticImage;
  hideAvatar?: boolean;
  className?: string;
}) {
  const avatarURL = useVirtualAssistantAvatar();

  const { url, link_url, alignment = 'left', scale = 100 } = chatItem;

  const alignmentClass = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
  }[alignment];

  const containerStyle = {
    maxWidth: `${scale}%`,
    height: 'auto',
  };

  const imageElement = (
    <img
      src={url}
      alt="Chat image"
      className="shadow-sm max-w-full h-auto"
      loading="lazy"
    />
  );

  const content = link_url ? (
    <a
      href={link_url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block"
      style={containerStyle}
    >
      {imageElement}
    </a>
  ) : (
    <div
      style={containerStyle}
      className="inline-block"
    >
      {imageElement}
    </div>
  );

  return (
    <BaseChatItem
      avatarURL={avatarURL}
      className={cx('ostro-chat-item-static-image', className)}
      showAvatar={!hideAvatar}
      isUserMessage={false}
    >
      <div className={cx('flex w-full', alignmentClass)}>{content}</div>
    </BaseChatItem>
  );
}
